import React from "react";

import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Checkbox, ListItemText } from "@material-ui/core";
import { i18n } from "../../translate/i18n";

const TicketsWhatsappSelect = ({
	whatsApps = [],
	selectedWhatsappIds = [],
	onChange,
	style,
}) => {
	const handleChange = e => {
		onChange(e.target.value);
	};

	const labelFor = wa => {
		const phone = wa.displayPhoneNumber || wa.number || "";
		if (wa.name && phone) return `${wa.name} (${phone})`;
		return wa.name || phone || `#${wa.id}`;
	};

	return (
		<div style={{ width: 160, marginTop: -4, ...(style || {}) }}>
			<FormControl fullWidth margin="dense">
				<Select
					multiple
					displayEmpty
					variant="outlined"
					value={selectedWhatsappIds}
					onChange={handleChange}
					MenuProps={{
						anchorOrigin: {
							vertical: "bottom",
							horizontal: "left",
						},
						transformOrigin: {
							vertical: "top",
							horizontal: "left",
						},
						getContentAnchorEl: null,
					}}
					renderValue={() => i18n.t("ticketsWhatsappSelect.placeholder")}
				>
					{whatsApps?.length > 0 &&
						whatsApps.map(wa => (
							<MenuItem dense key={wa.id} value={wa.id}>
								<Checkbox
									size="small"
									color="primary"
									checked={selectedWhatsappIds.indexOf(wa.id) > -1}
								/>
								<ListItemText primary={labelFor(wa)} />
							</MenuItem>
						))}
				</Select>
			</FormControl>
		</div>
	);
};

export default TicketsWhatsappSelect;
